<template lang="pug">
  .consultation--output-category.output-fields
    div(v-for="field in fields_" :key="field.id")
      v-flex.xs12(:class="(isVertrag || !showCustomerPref_) || isConcept ? 'md12' : 'md8'")
        field-row(
          :field="field"
          :label-class="`ml-${ indentSize * 4 }`"
          :force-edit="isConceptStatus && isConceptEdit && !isPrint"
          @update="(id, v) => $emit('update', id, v)"
        )

      v-flex.xs12.pt-2(v-if="field.grp" :class="(isVertrag || !showCustomerPref_) || isConcept ? 'md12' : 'md8'")
        hr.mt-1(v-if="field.groups" :class="`ml-${ indentSize * 4 }`")

        v-expansion-panels.flat-panels.output-groups(
          :value="getGroupPanelValue(field.groups)"
          flat
          tile
          multiple
        )
          v-expansion-panel.group-panel.mt-4(
            v-for="k_ in Object.keys(field.groups || {})"
            :key="k_"
            :id="`group-panel-${ k_ }`"
            @change="onTogglePanel"
          )
            v-expansion-panel-header(:class="`ml-${ indentSize * 4 }`") {{ getGroupHeader(field.groups[k_]) }}
            v-expansion-panel-content.py-3(eager)
              .group-fields(:id="`group-fields-${ k_ }`"): template(v-for="f in field.groups[k_]")
                field-row(
                  :key="f.id"
                  :field="f"
                  :label-class="`ml-${ (indentSize + 1) * 4 }`"
                  :force-edit="isConceptStatus && isConceptEdit && !isPrint"
                  @update="(id, v) => $emit('update', id, v)"
                )

              hr.mt-2(:class="[`ml-${ indentSize * 4 }`, isConcept && 'concept-hr']")

      v-flex.xs12(v-if="field.sub_fields")
        .output-location(v-for="l in field.sub_fields.locations" :key="l.id")
          h4.primary--text.pt-3.pb-1(v-if="l.id !== '#'") Standort {{ l.name }}

          output-category(
            :fields="l.fields"
            :buildings="l.buildings"
            :indent-size="l.id === '#' ? 1 : 2"
            :is-concept-status="isConceptStatus"
            @update="(id, v) => $emit('update', id, v)"
          )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import FormMixin from '@/mixins/form'

@Component({
  components: {
    FieldRow: () => import('./field-row'),
  },

  mixins: [
    FormMixin
  ],

  computed: mapGetters([
    'isVertrag',
    'isConcept',
    'isConceptEdit',
    'showCustomerPref'
  ]),
})
export default class OutputFields extends Vue {
  @Prop({ type: Array, default: () => [] }) fields
  @Prop({ type: Number, default: 0 }) indentSize
  @Prop({ type: Boolean, default: false }) printCustomerPref
  @Prop({ type: Boolean, default: false }) printVertrag
  @Prop({ type: Boolean, default: false }) isPrint
  @Prop({ type: Boolean, default: false }) isConceptStatus

  get fields_ () {
    return this.groupBySubSections(this.fields)
  }

  get showCustomerPref_ () {
    return this.isPrint
      ? this.printCustomerPref
      : this.showCustomerPref
  }

  mounted () {
    setTimeout(() => {
      this.alignGroupElements()
    }, 500)
  }

  getGroupPanelValue (groups) {
    if (!groups) {
      return []
    }

    const groupCount = Object.keys(groups).length
    return (new Array(groupCount))
      .fill(0)
      .map((_, i) => i)
  }

  getGroupHeader (fields) {
    if (!fields || !fields.length) {
      return ' '
    }

    return fields[0].value || ' '
  }

  groupBySubSections (fields) {
    const getAttachedFields = (fields_) => {
      const attachedFields = []
      return fields_
        .map((f, i) => {
          if (!f.styling) {
            return f
          }

          if (f.styling.attach_next && fields_[i + 1]) {
            f.next_field = fields_[i + 1] || null
            attachedFields.push(fields_[i + 1].id)
          }

          return f
        })
        .filter(f => (
          !f.hidden && !attachedFields.includes(f.id))
        )
    }

    return getAttachedFields(fields)
      .map(f => {
        if (f.groups) {
          Object.keys(f.groups).forEach(k => (f.groups[k] = getAttachedFields(f.groups[k])))
        }
        return f
      })
  }

  onTogglePanel () {
    // this.resetGroupElements()
    setTimeout(() => {
      this.alignGroupElements()
    }, 500)
  }
}
</script>

<style lang="sass" scoped>
.group-add-row
  top: 148px

.concept-hr
  position: absolute
  bottom: 0
  left: 0
  right: 0
</style>
